/*Quick View JS start*/
   function sliderFor(){
    return {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      fade: true,
      asNavFor: '.slider-nav',
      prevArrow:'<button class="previous-btn-cls-ctm"><svg aria-hidden="true" viewBox="0 0 512 512" class=""><path fill="currentColor" d="M358 512c4 0 7-1 9-4 5-5 5-13 0-18L146 269 367 47c5-5 5-13 0-18s-13-5-18 0L119 260c-5 5-5 13 0 18l230 230c3 3 6 4 9 4z"></path></svg></button>',
      nextArrow:'<button class="next-btn-cls-ctm"><svg aria-hidden="true" viewBox="0 0 512 512" class=""><path fill="currentColor" d="M128 512c-3 0-7-1-9-4-5-5-5-13 0-18l221-221L119 47c-5-5-5-13 0-18s13-5 18 0l230 231c5 5 5 13 0 18L137 508c-2 3-6 4-9 4z"></path></svg></button>'
    }
  }

  function sliderNav(){
    return {
      slidesToShow: 4,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      centerMode: false,
      arrows: false,
      focusOnSelect: true
    }
  }
 $('.quick-view-button-wrapper').on('click', function() {
    var productId = $(this).data('product-handle');
    var product_price = $(this).parents('.ProductItem__Wrapper').find('.ProductItem__PriceList').html();
    const product_vendor = $(this).parents('.ProductItem__Wrapper').find('.ProductItem__Vendor').text();
    $.get('/products/' + productId + '?view=quick-view', function(data) {
      $('#quick-view-popup').html(data);
      $('#quick-view-popup').find('.product-price').html(product_price);
      $('#quick-view-popup').find('.ProductItem__Vendor').html(product_vendor);
      $('#quick-view-popup').fadeIn();
      $('.slider-for').slick(sliderFor());
      $('.slider-nav').slick(sliderNav());
    });
  });

  if($(window).width() < 768) {
    var imageHeight = $('.jtpl__cstm_collection .ProductItem__Wrapper a.ProductItem__ImageWrapper').height();
    var ttlHeight = imageHeight - 45;
    $('.jtpl__cstm_collection .ProductItem__Wrapper .quick-view-button-wrapper').css('top', ttlHeight);
  }


  $(window).resize(function() {
    if($(window).width() < 768) {
      var imageHeight = $('.jtpl__cstm_collection .ProductItem__Wrapper a.ProductItem__ImageWrapper').height();
      var ttlHeight = imageHeight - 45;
      $('.jtpl__cstm_collection .ProductItem__Wrapper .quick-view-button-wrapper').css('top', ttlHeight);
    }
    var carouselHeight = $('.template-index .ProductList .ProductItem__Wrapper a.ProductItem__ImageWrapper').height();
    var ttlCarouselHeight = carouselHeight / 2;
    $('.template-index .ProductList .ProductItem__Wrapper .quick-view-button-wrapper').css('top', ttlCarouselHeight);
  });
  var carouselHeight = $('.template-index .ProductList .ProductItem__Wrapper a.ProductItem__ImageWrapper').height();
  var ttlCarouselHeight = carouselHeight / 2;
  $('.template-index .ProductList .ProductItem__Wrapper .quick-view-button-wrapper').css('top', ttlCarouselHeight);

 $(document).mouseup(function(e) {
    var container = $(".quick-view-content");
    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('#quick-view-popup').hide();
    }
  });

  $(document).on('click','.qlightbox__close', function(){
    $('#quick-view-popup').hide();
  });

  function domeChange() {
    let elem = document.querySelector('body'); // target div in which you want to detect changes
    let observer = new MutationObserver(mutationRecords => {
    
    });

    // observe everything except attributes
    observer.observe(elem, {
      childList: true, // observe direct children
      subtree: true, // and lower descendants too
      characterData: true,
      oldValue: true,
      characterDataOldValue: true // pass old data to callback
    });
}
domeChange();

  $(document).on("click",".read_more_less",function(e) {   
    e.preventDefault();
    $(this).addClass('rm-hide');
    $('.read_more_less').not($(this)).removeClass('rm-hide');   
         $('.quick-view-content').toggleClass('expand_content');
});

 $(document).on('click','.quick-view-content .option_title',function(){
    $(this).parents('.option_main_container').find('.option_list').slideToggle();
})

  $(document).on('click','.quick-view-content ul .option_value',function(){
   var data_handle =  $(this).attr('data-option');
    var selected_val =  $(this).text();
    $(this).parents('.option_main_container').find('.selected_value').text(selected_val);
                      $(this).addClass('selected');
                      $(this).parents('.option_list').slideUp();
$(this).parent('.option_list').find('li').not($(this)).removeClass('selected');
   
    console.log(data_handle);
    if($('.option_main_container').length >1){
        var selected_val1;
      var i=0;
        $('ul .option_value.selected').each(function(index){
       var selected_val =  $(this).attr('data-option');
            if(i == 0){
            selected_val1 =selected_val;
            }else {
              selected_val1 =  selected_val1+'-'+selected_val
            }
          i++;
        });
       $('.selector select option').removeAttr('selected');
      $('.selector select option[data-handle="'+selected_val1+'"]').attr('selected',true);
        var selected_id = $('.selector select option[data-handle="'+selected_val1+'"]').attr('data-id');
        var selected_pirce = $('.selector select option[data-handle="'+selected_val1+'"]').attr('data-price');
        var selected_sku = $('.selector select option[data-handle="'+selected_val1+'"]').attr('data-sku');
        var selected_barcode = $('.selector select option[data-handle="'+selected_val1+'"]').attr('data-barcode');
        $('.quick-view-content .product-price .ProductItem__Price').text(selected_pirce);
        $('.quick-view-content .qview-btn').attr('data-id',selected_id);
        $('.quick-view-content .ProductMeta__Sku .ProductMeta__SkuNumber').text(selected_sku);
        $('.quick-view-content .ProductMeta__Barcode .ProductMeta__BarcodeNumber').text(selected_barcode);
        if($('.selector select option[data-handle="'+selected_val1+'"]').hasClass('sold-out')){
            $('.quick-view-content .qview-btn .qview-btn__text').text('Out of stock');
            $('.quick-view-content .qview-btn').attr('disabled',true); 
        }else{
            $('.quick-view-content .qview-btn').attr('disabled',false);
             $('.quick-view-content .qview-btn .qview-btn__text').text('ADD TO CART');
        }
        var selectElement = $('.selector select')[0]; 
        if (selectElement) {
          var event = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(event);
        }
    }else if($('.option_main_container').length ==1){
        $('.selector select option[data-handle="'+data_handle+'"]').attr('selected',true);
        var selectElement = $('.selector select')[0]; 
        if (selectElement) {
          var event = new Event('change', { bubbles: true });
          selectElement.dispatchEvent(event);
        }
        var selected_id = $('.selector select option[data-handle="'+data_handle+'"]').attr('data-id');
        var selected_pirce = $('.selector select option[data-handle="'+data_handle+'"]').attr('data-price');
        var selected_sku = $('.selector select option[data-handle="'+data_handle+'"]').attr('data-sku');
        var selected_barcode = $('.selector select option[data-handle="'+data_handle+'"]').attr('data-barcode');      
        $('.quick-view-content .product-price .ProductItem__Price').text(selected_pirce);
        $('.quick-view-content .qview-btn').attr('data-id',selected_id);
        $('.quick-view-content .ProductMeta__Sku .ProductMeta__SkuNumber').text(selected_sku);
        $('.quick-view-content .ProductMeta__Barcode .ProductMeta__BarcodeNumber').text(selected_barcode);
        
        if($('.selector select option[data-handle="'+data_handle+'"]').hasClass('sold-out')){
            $('.quick-view-content .qview-btn .qview-btn__text').text('Out of stock');
            $('.quick-view-content .qview-btn').attr('disabled',true); 
        }else{
            $('.quick-view-content .qview-btn').attr('disabled',false);
             $('.quick-view-content .qview-btn .qview-btn__text').text('ADD TO CART');
        }
      
    }
});
  $('body').on('click','.quick-view-swatch li input',function(){
var v_handle=$(this).attr('valhandle');
var v_title=$(this).val();
    $('.option_main_container li[data-option="'+v_handle+'"]').trigger('click');
$(this).parents('.ProductForm__Option ').find('.ProductForm__SelectedValue').html(v_title).attr('data-handle',v_handle);
});
 $(document).mouseup(function(e) 
    {
    var container = $(".option_title");
      if (!container.is(e.target) && container.has(e.target).length === 0)  {
       $(".option_list").slideUp();
      }
  //  $('.qview-response').hide();
    }); 
  $(document).on('click','.qview-input-plus', function(){
    var quantValPlus = $('.qview-input').attr('value');
    $('.qview-input').attr('value',Number(quantValPlus)+1);
  });

  $(document).on('click','.qview-input-minus', function(){
    var quantValMinus = $('.qview-input').attr('value');
    if(quantValMinus > 1){
      $('.qview-input').attr('value',Number(quantValMinus)-1);
    }
  });

  $(document).on('click','.qview-btn-addtocart',function(e){
    var $this = $(this);
    // $(this).addClass('qview-processing');
    var get_id = $(this).attr('data-id');
    var quant = Number($('.qview-input').attr('value'));
    var cartData = {
        quantity: quant,
        id: get_id
    };

    // Globo Preorder on quickview
    if ($this.hasClass('gPreorderBtn')) {
      // check form preorder quickview
      var $form = $this.closest('.quickviewPreOrderForm');
      // add locale & selling_plan
      var preorderLocale = $form.find('input[name*="properties[_preorder_locale]"]').val()
      var sellingPlan = $form.find('input[name="selling_plan"]:checked').val();
      // add selling_plan data
      if (sellingPlan) {
        cartData.selling_plan = sellingPlan;
      }
      // add object properties data
      cartData.properties = {
        _preorder_locale: preorderLocale,
        _is_preorder: true
      };
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: cartData,
      dataType: 'json', 
      success: function (data) { 
          $('.qview-response').show().delay(3000).fadeOut('slow');
          // $this.removeClass('qview-processing');
      },
        error: function (error) {
          $('.error_msg').html(error.responseJSON.description);
      $('.error_msg').fadeIn();
      $('.error_msg').fadeOut(10000);
    
      }
    });
    
  });